export default {
    state: {
        smsCampaign: localStorage.getItem('smsCampaign') ?? {},
        excludedSMSCampaignIds: localStorage.getItem('excludedSMSCampaignIds') ? localStorage.getItem('excludedSMSCampaignIds') : []

    },
    mutations: {
        setSMSCampaign(state, campaign) {
            state.smsCampaign = campaign
        },
        setExcludedSMSCampaignIds(state, excludedSMSCampaignIds) {
            state.excludedSMSCampaignIds = excludedSMSCampaignIds
        }
    },
    actions: {
        setCurrentSMSCampaign({ commit }, campaign) {
            localStorage.setItem('smsCampaign', campaign)
            commit('setSMSCampaign', campaign)
        },
        setCurrentExcludedSMSCampaignIds({ commit }, excludedSMSCampaignIds) {
            localStorage.setItem('excludedSMSCampaignIds', excludedSMSCampaignIds)
            commit('setExcludedSMSCampaignIds', excludedSMSCampaignIds)
        }
    },
    getters: {
        getCurrentSMSCampaign: state => state.smsCampaign,
        getCurrentExcludedSMSCampaignIds: state => state.excludedSMSCampaignIds

    }
}
